// DynamicFormRenderer içindeki statik arayüz metinleri (buton, placeholder, ipucu).
// Form alan etiketleri (Label) formdan olduğu gibi gelir; yalnızca şablonun sabit
// metinleri buradan çevrilir. Dil, formun kendi çözümlenen diline göre seçilir —
// admin panelindeki genel dil değiştiriciden bağımsızdır.
const SUPPORTED = ['tr', 'en', 'de'];

function normalize(language) {
  if (!language) return 'tr';
  const code = String(language).trim().toLowerCase().split('-')[0];
  return SUPPORTED.includes(code) ? code : 'tr';
}

const TEXTS = {
  tr: {
    selectPlaceholder: 'Seçiniz',
    noOptions: 'Bu alana henüz seçenek tanımlanmamış.',
    optionFallback: (n) => `Seçenek ${n}`,
    uploadPlaceholder: 'Dosya seçmek için tıklayın',
    fileHint: 'Tüm dosya tipleri',
    requiredTitle: 'Zorunlu alan',
    submit: 'Gönder',
    submitting: 'Gönderiliyor...',
    formEyebrow: 'Form',
  },
  en: {
    selectPlaceholder: 'Select',
    noOptions: 'No options have been defined for this field yet.',
    optionFallback: (n) => `Option ${n}`,
    uploadPlaceholder: 'Click to choose a file',
    fileHint: 'All file types',
    requiredTitle: 'Required field',
    submit: 'Submit',
    submitting: 'Submitting...',
    formEyebrow: 'Form',
  },
  de: {
    selectPlaceholder: 'Auswählen',
    noOptions: 'Für dieses Feld wurden noch keine Optionen definiert.',
    optionFallback: (n) => `Option ${n}`,
    uploadPlaceholder: 'Klicken Sie, um eine Datei auszuwählen',
    fileHint: 'Alle Dateitypen',
    requiredTitle: 'Pflichtfeld',
    submit: 'Senden',
    submitting: 'Wird gesendet...',
    formEyebrow: 'Form',
  },
};

export function getFormRendererTexts(language) {
  return TEXTS[normalize(language)];
}
